var exports = {
  "iT": "toolContainer__N6nxqs",
  "kl": "toolContainerInGroup__4_7-Bb",
  "xY": "toolContainerBorderless__-pX9wO",
  "nC": "toolContainerExpanded__jRb1iX",
  "e$": "viewDiffContainer__gkRb1P",
  "xc": "createDiffContainer__ebfRi9",
  "D": "toolContainerDefault__eynJN7",
  "wH": "toolContentPreview__p6xrjL",
  "Rv": "toolContentMissionControl__fWNUFv",
  "xL": "toolContentBorderless__7oxaNX",
  "DG": "ToolContentFit__ToYF84",
  "wS": "PatchOperation__aS0FbU",
  "IR": "PatchOperationTitle___XVxzk",
  "$j": "PatchOperationPath__6kGU8w",
  "t3": "toolCodeOutput__efGMAU",
  "Gb": "toolCodeOutputScrollable__PVE7O9",
  "S_": "toolContent__dKYgJi",
  "Zy": "diffPreviewFooter__48jaH9",
  "ip": "diffPreview__JiJ5GJ",
  "HK": "toolDuration__7_K4-Z",
  "Y8": "toolDurationDot__a0VM75",
};

module.exports = exports;
